import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "common/components/Button/Button"
import { useDispatch } from "hooks/useDispatch"
import { useTranslation } from "react-i18next"
import { setShowDocumentoEditadoModal } from "../redux/slices/newDocumentoSettingsSlice"

const DocumentoEditado = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const goBack = () => {
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(setShowDocumentoEditadoModal(false))
  }

  return (
    <div className='container pl-5 pr-5 d-flex flex-column align-items-center'>
      <div className='circle-gray'>
        <div className='circle-gray__intern'>
          <FontAwesomeIcon
            icon={["fal", "check"]}
            className='big-check-icon'
          />
        </div>
      </div>

      <h5 className='mt-2 text-center'>
        {t("crear.facturaRec.modal.editExitMsg")}
      </h5>

      <div className='mt-4 w-100'>
        <div className='mt-3'>
          <Button
            className='tw-w-full tw-py-4'
            onClick={goBack}
          >
            {t("crear.facturaRec.modal.endLabel")}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default DocumentoEditado
